import { render, staticRenderFns } from "./ShadowsModule.vue?vue&type=template&id=169a6500&scoped=true"
import script from "./ShadowsModule.vue?vue&type=script&lang=js"
export * from "./ShadowsModule.vue?vue&type=script&lang=js"
import style0 from "./ShadowsModule.vue?vue&type=style&index=0&id=169a6500&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169a6500",
  null
  
)

export default component.exports